import { render, staticRenderFns } from "./AcceptanceRate.vue?vue&type=template&id=874f7e02&scoped=true&"
import script from "./AcceptanceRate.vue?vue&type=script&lang=js&"
export * from "./AcceptanceRate.vue?vue&type=script&lang=js&"
import style0 from "./AcceptanceRate.vue?vue&type=style&index=0&id=874f7e02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874f7e02",
  null
  
)

export default component.exports